// ----------------------------------------------------------------------------
// !!!!!  TODO refactor this to support Pinia instead of vuex
// ----------------------------------------------------------------------------

// ----------------------------------------------------------------------------
// generator for network call that should have only one in flight.
// ----------------------------------------------------------------------------

export function networkDebounce(
	localAction: any,
	pvwAction: any,
	argExtract: any,
	activeLayer: any, // returned val is supplied as arg to pvwAction
	respHandler = null as any
) {
	// closure
	let pendingRequest = 0;
	return (ctx: any) => {
		pendingRequest++;
		if (pendingRequest === 1) {
			// remote request, only want one in flight.
			// any args must come from the store/getters, since
			// we call recursively.
			return ctx
				.dispatch(pvwAction, {
					event: argExtract(ctx),
					layerName: activeLayer(ctx)
				})
				.then((response: any) => {
					if (respHandler) respHandler(ctx, response);
					pendingRequest--;
					if (pendingRequest) {
						// if more were requested while in flight, send another.
						pendingRequest = 0;
						return ctx.dispatch(localAction);
					}
				})
				.catch((e: any) => {
					if (ctx.getters.PVW_CLIENT) {
						console.error(e);
					}
					pendingRequest = 0;
				});
		}
	};
}

// ----------------------------------------------------------------------------

export function deferredCallback(callback: any) {
	let globalList: any = [];
	let deferCallback = true;
	return {
		listener: (list: any) => {
			if (deferCallback) {
				for (let i = 0; i < list.length; i++) {
					globalList.push(list[i]);
				}
			} else {
				callback(list);
			}
		},
		flush() {
			deferCallback = false;
			if (globalList.length) {
				callback(globalList);
				globalList = [];
			}
		}
	};
}

// ----------------------------------------------------------------------------

export default {
	networkDebounce,
	deferredCallback
};
